class DotoProductShare extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.trigger = this.querySelector('[data-element="share-trigger"]');
    this.modal = document.getElementById(this.dataset.modalId || '');
    this.onTrigger = this.onTrigger.bind(this);
    this.onKeydown = this.onKeydown.bind(this);

    this.trigger?.addEventListener('click', this.onTrigger);
    this.querySelectorAll('clipboard-copy[tabindex="0"]').forEach((copy) => {
      copy.addEventListener('keydown', this.onKeydown);
    });
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.onTrigger);
    this.querySelectorAll('clipboard-copy[tabindex="0"]').forEach((copy) => {
      copy.removeEventListener('keydown', this.onKeydown);
    });
  }

  isMobile() {
    return window.matchMedia('(max-width: 991px)').matches;
  }

  async onTrigger() {
    const shareData = {
      title: this.dataset.shareTitle || document.title,
      text: this.dataset.shareText || '',
      url: this.dataset.shareUrl || window.location.href
    };

    if (this.isMobile() && navigator.share) {
      try {
        await navigator.share(shareData);
        return;
      } catch (error) {
        if (error?.name === 'AbortError') return;
      }
    }

    this.openDesktopOverlay();
  }

  openDesktopOverlay() {
    if (!this.modal) return;
    if (typeof this.modal.open === 'function') {
      this.modal.open();
      return;
    }
    const dialog = this.modal.querySelector('dialog');
    dialog?.showModal?.();
  }

  onKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    event.currentTarget.click();
  }
}

if (!customElements.get('doto-product-share')) {
  customElements.define('doto-product-share', DotoProductShare);
}
